import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, finalize, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import {
  CloseMovementsResponse,
  Movements,
  MovementsResponse,
} from 'src/app/core/models/position-operations/end-outbound-scan-gle';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/app/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class EndOutboundScanGleService {
  private readonly _http = inject(HttpClient);
  private readonly _commonUtils = inject(CommonUtils);
  private readonly _errorHandler = inject(ErrorhandleService);

  readonly baseUrl = environment.apiUrl.concat('/outbound/end');

  /**
   *Get Stoppable Movements
   * @return {*}  {Observable<MovementsResponse>}
   * @memberof EndOutboundScanGleService
   */
  getStoppableMovements(): Observable<MovementsResponse> {
    this._commonUtils.updateLoadingModal(true);
    return this._http
      .get<MovementsResponse>(this.baseUrl.concat('/get-stoppable-mvmts'))
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<MovementsResponse>(
            error,
            error.error.code,
            'EndOutboundScanGle Service: Movements',
            BANNER_TYPE.TABLE_DATA_ERROR,
          ),
        ),
        finalize(() => {
          this._commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   *close movement
   * @return {*}  {Observable<CloseMovementsResponse>}
   * @memberof EndOutboundScanGleService
   */
  closeMovement(
    movementRequest: Movements,
  ): Observable<CloseMovementsResponse> {
    this._commonUtils.updateLoadingModal(true);
    return this._http
      .post<CloseMovementsResponse>(
        this.baseUrl.concat('/close-movement'),
        movementRequest,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<CloseMovementsResponse>(
            error,
            error.error.code,
            'EndOutboundScanGle Service: Close Movement',
            BANNER_TYPE.API_400_ERROR,
          ),
        ),
        finalize(() => {
          this._commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
